import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  doc as firebaseDoc,
  getFirestore,
  collection,
  getDocs,
  runTransaction,
} from "firebase/firestore";

// ... [rest of the imports]

export const verifyAvailability = createAsyncThunk(
  "carAvailability/verifyAvailability",
  async (_, { getState }) => {
    const { date, session, people } = getState().carAvailability;
    const db = getFirestore();

    // Get the list of active cars from the database
    const activeCars = await getActiveCarsFromDatabase();

    // We're using transaction to read the document
    return runTransaction(db, async (transaction) => {
      const carsNeeded = Math.ceil(people / 9);

      if (!date || !session) {
        throw new Error("Invalid date or session.");
      }

      if (session === "full day") {
        const morningDocId = `${date}_morning`;
        const afternoonDocId = `${date}_afternoon`;

        const morningDocRef = firebaseDoc(db, "carAvailability", morningDocId);
        const afternoonDocRef = firebaseDoc(
          db,
          "carAvailability",
          afternoonDocId
        );

        const morningDoc = await transaction.get(morningDocRef);
        const afternoonDoc = await transaction.get(afternoonDocRef);

        // Check availability for morning session
        if (morningDoc.exists()) {
          const availableMorningCars = activeCars.filter(
            (car) => morningDoc.data()[car]
          ).length;
          if (availableMorningCars < carsNeeded) {
            throw new Error(
              `Not enough available cars for morning session: ${availableMorningCars} available, ${carsNeeded} cars needed`
            );
          }
        } else if (carsNeeded > activeCars.length) {
          throw new Error(
            `Not enough cars for morning session. Total cars: ${activeCars.length}, Cars needed: ${carsNeeded}`
          );
        }

        // Check availability for afternoon session
        if (afternoonDoc.exists()) {
          const availableAfternoonCars = activeCars.filter(
            (car) => afternoonDoc.data()[car]
          ).length;
          if (availableAfternoonCars < carsNeeded) {
            throw new Error(
              `Not enough available cars for afternoon session: ${availableAfternoonCars} available, ${carsNeeded} cars needed`
            );
          }
        } else if (carsNeeded > activeCars.length) {
          throw new Error(
            `Not enough cars for afternoon session. Total cars: ${activeCars.length}, Cars needed: ${carsNeeded}`
          );
        }
      } else {
        const docId = `${date}_${session}`;
        const docRef = firebaseDoc(db, "carAvailability", docId);
        const doc = await transaction.get(docRef);

        if (!doc.exists()) {
          if (carsNeeded > activeCars.length) {
            throw new Error(
              `Not enough cars for this booking. Total cars: ${activeCars.length}, Cars needed: ${carsNeeded}`
            );
          }
        } else {
          const availableCars = activeCars.filter(
            (car) => doc.data()[car]
          ).length;
          if (availableCars < carsNeeded) {
            throw new Error(
              `Not enough available cars: ${availableCars} available, ${carsNeeded} cars needed`
            );
          }
        }
      }

      return { status: "available" };
    }).catch((error) => {
      console.error("Transaction failed: ", error);
      throw error;
    });
  }
);

// ... [rest of the code]

async function getActiveCarsFromDatabase() {
  try {
    const db = getFirestore();
    const carsCollection = collection(db, "cars"); // replace "cars" with your actual collection name
    const carSnapshot = await getDocs(carsCollection);
    const activeCars = [];
    carSnapshot.forEach((doc) => {
      if (doc.data().status === "active") {
        // replace "status" with your actual field name
        activeCars.push(doc.data().carName); // replace "carName" with your actual field name
      }
    });
    console.log("Active Cars:", activeCars);
    return activeCars;
  } catch (error) {
    console.error("Error fetching active cars:", error);
    throw error; // This will propagate the error up to the calling function
  }
}
